import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";

export const MakePaymentMail = () => {

  const { type } = useParams();

  const [mailType, setMailType] = useState(type);

  useEffect(() => {
    setMailType(type);
  }, [type]);

  useEffect(() => {
    axiosInstance
      .post("MakePaymentMail/PaymentMail", {
        Resendmail: null,
        SubmitedMailBT: "true",
      })
      .then((response) => {
        if (response.data && response.data) {
        }
      })
      .catch((error) => console.log(error.message));
  }, []);

  return (
    <Fragment>
      <></>
    </Fragment>
  );
};
